import { Loan, MpmLoan } from '@shared/enums/loan-type.enum';

export const ChartColors = {
  Blue: '#99cbf3',
  Red: '#f0928f',
  Green: '#9dd49d',
  Yellow: '#fce594'
}

export interface OpportunityActivitySummary {
  period: string;
  home: number;
  smsf: number;
  personal: number;
  car: number;
  refix: number;
  insurance: number;
}

export interface Activity {
  color: string;
  loanType: Loan | MpmLoan;
  value: number;
}
